import React from 'react';

import { useFieldQuery } from '../../hooks/useFieldQuery';
import { StaticFieldComponent } from '../StaticFieldComponent/StaticFieldComponent';
import { SectionSkeleton } from '../../sections/Sections/SectionSkeleton';

import { FieldQueryError } from './FieldQueryError';

export function FieldSwitch({
  fieldKey,
  sectionKey,
  path = [],
  propagateFieldLabelToParent,
}: {
  fieldKey: string;
  sectionKey: string;
  path?: string[];
  propagateFieldLabelToParent?: (path: string[], label: string | string[]) => void;
}) {
  const { isVisible, fieldQuery, retryFn } = useFieldQuery(sectionKey, fieldKey, path);

  if (fieldQuery.isLoading) {
    return <SectionSkeleton currentSectionKey={sectionKey} />;
  }

  if (fieldQuery.error) {
    return <FieldQueryError error={fieldQuery.error} fieldKey={fieldKey} onRetry={retryFn} />;
  }

  if (!fieldQuery.data) {
    return null;
  }

  switch (fieldQuery.type) {
    case 'DynamicFields': {
      if (!isVisible) {
        return null;
      }

      return (
        <React.Fragment key={fieldKey}>
          {fieldQuery.data.map((fieldKey2) => (
            <FieldSwitch
              fieldKey={fieldKey2}
              key={fieldKey2}
              sectionKey={sectionKey}
              path={path}
              propagateFieldLabelToParent={propagateFieldLabelToParent}
            />
          ))}
        </React.Fragment>
      );
    }
    default: {
      return (
        <StaticFieldComponent
          key={fieldKey}
          field={fieldQuery.data}
          sectionKey={sectionKey}
          FieldSwitch={FieldSwitch}
          isVisible={isVisible}
          path={[...path, fieldQuery.data.key]}
          propagateFieldLabelToParent={propagateFieldLabelToParent}
        />
      );
    }
  }
}
